import useSWR from 'swr';

import { prepareConditionalSwrArgs } from 'hooks/prepare-conditional-swr-args';
import { ShowtimeService } from 'services/ShowtimeService';

const useQrScansSummary = ({ companyId }: { companyId: string }) => {
    const { data: summary, isLoading: isSummarizing } = useSWR(
        ...prepareConditionalSwrArgs({
            key: `/qrScansSummary?companyId=${companyId}`,
            fetcher: () => ShowtimeService.summarizeQrScans({ companyId }),
            condition: Boolean(companyId),
        }),
        // The endpoint only calls the LLM again when the scans changed, so polling stays cheap
        { refreshInterval: 5 * 60 * 1000, revalidateOnFocus: false },
    );

    return {
        summary,
        isSummarizing,
    };
};

export { useQrScansSummary };
